import React, { useEffect, useState } from "react";
import "../../assets/css/--home.css";

import HomeBanner from "./HomeBanner";
import HeartOfTown from "./HeartOfTown";
import RightHere from "./RightHere";
import CustomerSatisfying from "./CustomerSatisfying";
import WhatsCooking from "./WhatsCooking";
import HotSelling from "./HotSelling";
import BestSeller from "./BestSeller";
import ShoppingSection from "./ShoppingSection";
import FreshIngredientsSection from "./FreshIngredientsSection";
import ExperienceSection from "./ExperienceSection";
import DealsSection from "./DealsSection";
import HomeBannerMobile from "./HomeBannerMobile";
import ScrollToTop from "../../components/ScrollToTop";

import { getParentCategories } from "../../helper/backend-methods";

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);

      const response = await getParentCategories({
        store: 2,
      });

      setCategories(response?.data?.Data || []);
    } catch (error) {
      console.log("Category API Error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <HomeBanner />
      <HomeBannerMobile />
      <HeartOfTown />
      <RightHere categories={categories} loading={loading} />
      <CustomerSatisfying />
      <WhatsCooking />
      <HotSelling categories={categories} loading={loading} />
      <BestSeller />
      <DealsSection />
      <ShoppingSection />
      <FreshIngredientsSection />
      <ExperienceSection />
      <ScrollToTop />
    </>
  );
};

export default Home;
